export var CreditCardFields;
(function (CreditCardFields) {
    CreditCardFields["CARD_NUMBER"] = "number";
    CreditCardFields["LAST_NAME"] = "lastName";
    CreditCardFields["FIRST_NAME"] = "firstName";
    CreditCardFields["MONTH"] = "month";
    CreditCardFields["YEAR"] = "year";
    CreditCardFields["CVV"] = "cvv";
})(CreditCardFields || (CreditCardFields = {}));
